/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./Products.css";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import DataTableTemplatingDemo from "../../components/products/DataTableTemplatingDemo/DataTableTemplatingDemo";
import ModelAdd from "../../components/products/model/ModelAdd";
import AIPageProducts from "../../components/products/model/AIPageProducts";
import { addMultipleProducts } from "../../redux/products/productsActions";
import { updateProduct } from "../../redux/products/products";
import { db, storage } from "../../firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import axios from "axios";
import ModelShow from "../../components/products/model/ModelShow";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Import } from "lucide-react";

import { useTranslation } from "react-i18next";
import { serverTimestamp, doc, updateDoc } from "firebase/firestore";

import {
  Plus,
  Search,
  Package,
  Archive,
  AlertCircle,
  EyeOff,
  Sparkle,
} from "lucide-react";
import ProductExportModal from "../../components/products/model/ProductExportModal";
import { updateAccount } from "../../redux/account/account";
import { auth } from "../../firebase";

function Products() {
  const [lgShow, setLgShow] = useState(false);
  const [modelShow, setModelShow] = useState(false);
  const [showSideBar, setShowSideBar] = useState(true);
  const account = useSelector((state) => state.AccountReducer);
  const dispatch = useDispatch();

  const { t, i18n } = useTranslation();
  const direction = i18n.language === "ar" ? "rtl" : "ltr";
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [isProductsPageSizeOpen, setIsProductsPageSizeOpen] = useState(false);
  const GENERATE_LANDING_ENDPOINT =
    "https://backend.foorweb.net/api/v1/foorAiModel/productPage/generate-page";
  const productsPageSizeOptions = [
    { value: 5, label: t("Products.5prod") },
    { value: 10, label: t("Products.10prod") },
    { value: 25, label: t("Products.25prod") },
    { value: 50, label: t("Products.50prod") },
    { value: 100, label: t("Products.100prod") },
  ];

  const handleProductsPageSizeSelect = (value) => {
    setPageSize(value);
    setIsProductsPageSizeOpen(false);
  };

  const [data2, setData2] = useState(["", "", "", "", ""]);
  const store = useSelector((state) => state.StoreReducer);
  const products = useSelector((state) => state.ProductsReducer);
  const [pageSize, setPageSize] = useState(10);
  const [selectedFilterDate, setSelectedFilterDate] = useState("all");
  const [endDate, setEndDate] = useState("");
  const [aiModalShow, setAiModalShow] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false); //export product Modal
  const [exportModalOpen, setExportModalOpen] = useState(false);

  const handleOpenExportModal = () => {
    setExportModalOpen(true);
  };
  const MySwal = withReactContent(Swal);

  const message = () => {
    const MySwal = withReactContent(Swal);
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success mx-2",
        cancelButton: "btn btn-danger mx-2",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: t("services.contact_for_free_trial"),
        showCancelButton: true,
        confirmButtonText: t("ship.yes"),
        cancelButtonText: t("ship.no"),
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          window.open("https://m.me/F0orweb", "_blank", "noopener,noreferrer");
        } else result.dismiss === Swal.DismissReason.cancel;
      });
  };

  useEffect(() => {
    if (!!store.id) {
      const mainCategories = (store.categories || []).slice(0, 5);
      const additional =
        (store.additionalCategories || []).map((element) => element.title) ||
        [];
      setData2([...mainCategories, ...additional]);
    }
  }, [store]);

  const [filter, setFilter] = useState("");
  const [filter2, setFilter2] = useState("");

  const [images, setImages] = useState([
    {
      original: "https://picsum.photos/id/1018/1000/600/",
      thumbnail: "https://picsum.photos/id/1018/250/150/",
    },
    {
      original: "https://picsum.photos/id/1015/1000/600/",
      thumbnail: "https://picsum.photos/id/1015/250/150/",
    },
    {
      original: "https://picsum.photos/id/1019/1000/600/",
      thumbnail: "https://picsum.photos/id/1019/250/150/",
    },
  ]);

  const [data, setData] = useState({
    name: "",
    image: "",
    review: "",
    price: "",
    oldPrice: "",
    comment: "",
    qty: "",
    category_id: "",
    sku: "",
    show: "1",
    short: "",
    galleryServerDz: [],
    options: [
      {
        title: "1",
        color: "1",
        colorOption: [
          {
            option: "",
            color: "",
          },
        ],
      },
    ],
    discount: {
      freeDelivery: true,
      discountDelivery: 0,
      discountTotal: 0,
    },
    offers: [
      {
        title: "",
        qty: 0,
        price: 0,
      },
      {
        title: "",
        qty: 0,
        price: 0,
      },
      {
        title: "",
        qty: 0,
        price: 0,
      },
      {
        title: "",
        qty: 0,
        price: 0,
      },
    ],
    gallery: [],
    visits: 0,
    textEditor: "<p><br></p>",
    timeStamp: serverTimestamp(),
    type:
      (account.productMode ?? "classic") == "digital"
        ? "digitalProducts"
        : "classic",
  });

  const handleAdd = () => {
    setData({
      name: "",
      image: "",
      review: "",
      price: "",
      oldPrice: "",
      comment: "",
      qty: "",
      category_id: "",
      sku: "",
      show: "1",
      galleryServerDz: [],
      options: [
        {
          title: "",
          color: "1",
          colorOption: [
            {
              option: "",
              color: "",
            },
            {
              option: "",
              color: "",
            },
          ],
          option1: "",
          option2: "",
          option3: "",
          option4: "",
          color1: "",
          color2: "",
          color3: "",
          color4: "",
        },
      ],
      discount: {
        freeDelivery: false,
        activeStay: false,
        discountDelivery: 0,
        discountTotal: 0,
      },
      offers: [
        {
          title: "",
          qty: 0,
          price: 0,
        },
        {
          title: "",
          qty: 0,
          price: 0,
        },
        {
          title: "",
          qty: 0,
          price: 0,
        },
        {
          title: "",
          qty: 0,
          price: 0,
        },
      ],
      gallery: [],
      visits: 0,
      textEditor: "<p><br></p>",
      timeStamp: serverTimestamp(),
      type:
        (account.productMode ?? "classic") == "digital"
          ? "digitalProducts"
          : "classic",
    });
    setLgShow(true);
  };
  const handleModalSave = () => {};

  const handleTabChange = (tabKey) => {
    setSelectedFilterDate(tabKey);
  };

  const productMode = account?.productMode ?? "classic";

  // FoorAi landing pages are not product pages: exclude them from /products
  const nonLandingProducts =
    products?.filter((p) => p.created_via !== "FoorAiLandingPageGenerator") ||
    [];

  const filteredProducts =
    productMode === "classic"
      ? nonLandingProducts.filter(
          (p) => !p.type || p.type !== "digitalProducts",
        )
      : nonLandingProducts.filter((p) => p.type === "digitalProducts");

  const totalProducts = filteredProducts.length;
  const outOfStock = filteredProducts.filter((p) => p.qty <= 0).length;
  const lowStock = filteredProducts.filter(
    (p) => p.qty > 0 && p.qty <= p.limitedValue,
  ).length;
  const hiddenProducts = filteredProducts.filter((p) => p.show === "0").length;
  const aiGeneratedProducts = filteredProducts.filter(
    (p) => p.created_via === "FoorAiProductPageGenerator",
  ).length;
  const getFilteredProducts = () => {
    if (!products) return [];

    // Apply the date/category filter first
    let filteredProducts = [...nonLandingProducts];

    switch (selectedFilterDate) {
      case "recent":
        // Sort by timestamp (newest first)
        filteredProducts = filteredProducts
          .sort((a, b) => {
            if (!a.timeStamp || !b.timeStamp) return 0;
            return b.timeStamp.seconds - a.timeStamp.seconds;
          })
          .slice(0, 50); // Get the 50 most recent
        break;

      case "popular":
        // Sort by sales count if available, otherwise by viewCount
        filteredProducts = filteredProducts.sort((a, b) => {
          const aSales = a.salesCount || a.viewCount || 0;
          const bSales = b.salesCount || b.viewCount || 0;
          return bSales - aSales;
        });
        break;

      case "all":
      default:
        break;
    }

    if (filter2) {
      switch (filter2) {
        case "out_of_stock":
          filteredProducts = filteredProducts.filter((p) => p.qty <= 0);
          break;
        case "low_stock":
          filteredProducts = filteredProducts.filter(
            (p) => p.qty > 0 && p.qty <= p.limitedValue,
          );
          break;
        case "hidden":
          filteredProducts = filteredProducts.filter((p) => p.show === "0");
          break;
        case "ai_generated":
          filteredProducts = filteredProducts.filter(
            (p) => p.created_via === "FoorAiProductPageGenerator",
          );
          break;
        default:
          break;
      }
    }

    // Finally apply the search text filter
    if (filter) {
      const searchTerm = filter.toLowerCase();
      filteredProducts = filteredProducts.filter(
        (product) =>
          (product.name && product.name.toLowerCase().includes(searchTerm)) ||
          (product.sku && product.sku.toLowerCase().includes(searchTerm)),
      );
    }

    if ((account.productMode ?? "classic") == "classic") {
      filteredProducts = filteredProducts.filter(
        (p) => p.type !== "digitalProducts",
      );
    } else {
      filteredProducts = filteredProducts.filter(
        (p) => p.type === "digitalProducts",
      );
    }

    const orderIds =
      productMode === "digital"
        ? store?.digitalProductsOrder
        : store?.productsOrder;

    if (
      selectedFilterDate === "all" &&
      Array.isArray(orderIds) &&
      orderIds.length > 0
    ) {
      const orderMap = new Map(orderIds.map((id, index) => [id, index]));
      filteredProducts = [...filteredProducts].sort((a, b) => {
        const aIndex = orderMap.has(a.id)
          ? orderMap.get(a.id)
          : Number.MAX_SAFE_INTEGER;
        const bIndex = orderMap.has(b.id)
          ? orderMap.get(b.id)
          : Number.MAX_SAFE_INTEGER;

        if (aIndex !== bIndex) return aIndex - bIndex;

        const aName = (a.name || "").toString();
        const bName = (b.name || "").toString();
        return aName.localeCompare(bName);
      });
    }

    return filteredProducts;
  };
  const isRTL = i18n.language === "ar";

  // آخر نتيجة رجعها الباكاند (url, sku, gallery, textEditor...) باش نستعملوها
  // عند إنشاء المنتج مباشرة بعد التوليد
  const lastGeneratedRef = useRef(null);

  // الخطوة 1: نطلبو من الذكاء الاصطناعي يولد الصورة والوصف
  const handleGenerateLandingPage = async (payload) => {
    setIsGenerating(true);
    try {
      const formData = new FormData();

      // backend accepts file or url (not used now) string under the same field name
      if (payload.user) {
        formData.append("user", payload.user);
      }
      if (payload.product_image) {
        formData.append("product_image", payload.product_image);
      }
      formData.append("product_name", payload.product_name || "");
      formData.append("product_price", payload.product_price || "");
      formData.append("generation_prompt", payload.generation_prompt || "");
      if (payload.generation_language) {
        formData.append("generation_language", payload.generation_language);
      }
      if (payload.product_id) {
        formData.append("product_id", payload.product_id);
      }

      const currentUser = auth.currentUser;
      if (!currentUser) {
        throw new Error("يجب تسجيل الدخول أولاً.");
      }
      const idToken = await currentUser.getIdToken(/* forceRefresh */ true);

      const response = await axios.post(GENERATE_LANDING_ENDPOINT, formData, {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
        timeout: 5 * 60 * 1000,
      });

      if (!response.data?.ok || !response.data?.product) {
        throw new Error(response.data?.error);
      }

      // used later by handleConfirmAiPage
      lastGeneratedRef.current = response.data.product;

      if (response.data?.billing) {
        const b = response.data.billing;
        dispatch(
          updateAccount({
            subscription: {
              ...(account.subscription || {}),
              tokens:
                typeof b.tokens === "number"
                  ? b.tokens
                  : account.subscription?.tokens,
              aiProductPageFreeRemaining: b.freeRemaining,
              aiProductPageFreeMonth: b.monthKey,
            },
          }),
        );
      }
      return response.data; // { ok: true, product: {...} }
    } catch (err) {
      console.error("Error generating product page:", err);
      throw err;
    } finally {
      setIsGenerating(false);
    }
  };

  // إذا المستخدم بدّل الصورة فخطوة المراجعة تجي File، نرفعوها لـ Storage ونرجعو الرابط
  const resolveImageUrl = async (image) => {
    if (!image) return "";
    if (typeof image === "string") return image;
    const safeName = (image.name || "image").replace(/[^a-zA-Z0-9._-]/g, "_");
    const storageRef = ref(
      storage,
      `products/ai/${account?.user || "anon"}/${Date.now()}_${safeName}`,
    );
    await uploadBytes(storageRef, image);
    return await getDownloadURL(storageRef);
  };

  // الخطوة 2: نحفظ المنتج مباشرة بعد التوليد
  //  - منتج موجود  => نعدّلو غير الحقول اللي تبدلت (الصورة/الوصف) على نفس المنتج
  //  - منتج جديد   => نزيدو منتج جديد كيما قبل
  const handleConfirmAiPage = async (final) => {
    setIsGenerating(true);
    try {
      const generated = lastGeneratedRef.current || {};
      const pageImageUrl =
        generated.image ||
        generated.pageImage ||
        (Array.isArray(generated.gallery) && generated.gallery[0]) ||
        "";

      let finalImage = pageImageUrl;

      if (
        final?.image_edited &&
        final.image &&
        typeof final.image !== "string"
      ) {
        finalImage = await resolveImageUrl(final.image); // File → Storage
      } else if (
        final?.image &&
        typeof final.image === "string" &&
        !final.image.startsWith("blob:")
      ) {
        finalImage = final.image; // http(s) URL only
      }
      const finalShort = final.short || generated.short || "";
      const finalTextEditor = final.textEditor || generated.textEditor || "";

      if (final.product_source === "existing" && final.product_id) {
        const existing = (products || []).find(
          (p) => p.id === final.product_id,
        );
        if (!existing) throw new Error("المنتج المحدد غير موجود");

        // نبدلو غير المعلومات اللي ولّدها/عدّلها المستخدم، الباقي يبقى كيما هو
        const updates = {};
        if (finalShort && finalShort !== existing.short) {
          updates.short = finalShort;
        }
        if (finalTextEditor && finalTextEditor !== existing.textEditor) {
          updates.textEditor = finalTextEditor;
        }
        if (finalImage && finalImage !== existing.landingImage) {
          updates.landingImage = finalImage;
        }
        // الصورة الرئيسية للمنتج تتبدل فقط إذا المستخدم رفع صورة جديدة بنفسه
        if (final.image_edited && finalImage) {
          updates.image = finalImage;
        }

        if (Object.keys(updates).length === 0) {
          setAiModalShow(false);
          MySwal.fire({
            icon: "info",
            title: t("ui.noChanges"),
            text: t("ui.productUnchanged"),
            confirmButtonColor: "#9b59bf",
          });
          return true;
        }

        await updateDoc(doc(db, "products", existing.id), updates);
        dispatch(updateProduct({ ...existing, ...updates }));

        setAiModalShow(false);
        MySwal.fire({
          icon: "success",
          title: t("ui.editedSuccessfully"),
          text: t("ui.productUpdated"),
          confirmButtonColor: "#9b59bf",
        });
        return true;
      }

      // منتج جديد: نفس شكل المنتج لي كتبني ف ProductExportModal
      // url و sku جايين مباشرة من الباكاند (مخمنين من اسم المنتج)
      const newProduct = {
        url: generated.url || "",
        name:
          generated.name ||
          generated.marketingTitle ||
          final.product_name ||
          "",
        image: pageImageUrl,
        review: "5",
        price: String(generated.price || ""),
        oldPrice: "",
        comment: "",
        qty: "",
        googleSheetP: "",
        googleSheetPActive: false,
        visits: 0,
        category_id: "كل المنتجات",
        short: finalShort,
        delevery: false,
        upsell: false,
        sku: generated.sku || "",
        show: "1",
        options: [
          {
            title: "",
            color: "",
            option1: "",
            option2: "",
            option3: "",
            option4: "",
          },
        ],
        offers: [
          { title: "", qty: 0, price: 0 },
          { title: "", qty: 0, price: 0 },
          { title: "", qty: 0, price: 0 },
          { title: "", qty: 0, price: 0 },
        ],
        discount: {
          freeDelivery: false,
          activeStay: false,
          discountDelivery: 0,
          discountTotal: 0,
          seconds: 0,
        },
        gallery: generated.gallery || [],
        textEditor: finalTextEditor || "<p><br></p>",
        landingImage: finalImage || generated.landingImage || "",
        timeStamp: serverTimestamp(),
        created_via: "FoorAiProductPageGenerator",

        type:
          (account.productMode ?? "classic") === "digital"
            ? "digitalProducts"
            : "classic",
      };

      const result = await dispatch(addMultipleProducts([newProduct]));
      if (!result) throw new Error("فشلت إضافة المنتج");

      return true;
    } catch (err) {
      console.error("Error saving AI product page:", err);
      throw err;
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div
      className="container-fluid bg-gradient-to-br from-white to-purple-50 min-h-screen"
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 dark:!bg-[#141414]"
          style={{ flex: 1, backgroundColor: "#fbf8fc" }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          {/* Page Header */}
          <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-sm p-4 m-3 mt-6 border border-purple-100 dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-1">
                  {t("Products.title")}
                </h2>
                <p className="text-gray-600 dark:text-gray-200 mb-0">
                  {t("Products.description")}
                </p>
              </div>
            </div>
          </div>

          {/* Date Filter Tabs */}
          <div className="mx-3 mb-3 flex items-center justify-between">
            <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-sm border border-purple-100 dark:!border-[#3c3a3d] overflow-hidden">
              <div className="flex">
                <button
                  className={`px-6 py-3 text-sm font-medium transition-all duration-200 ${
                    selectedFilterDate === "all"
                      ? "bg-[#faf1ff] text-[#9e65bb] dark:text-gray-300 dark:bg-[#522868] border-b-2 border-[#9b59bf] shadow-sm"
                      : "text-gray-600 hover:bg-purple-50 hover:text-[#9e68ba] dark:hover:bg-[#6e358c] dark:text-gray-300"
                  }`}
                  onClick={() => handleTabChange("all")}
                >
                  {t("Products.tabs.all")}
                </button>
                <button
                  className={`px-6 py-3 text-sm font-medium transition-all duration-200 ${
                    selectedFilterDate === "recent"
                      ? "bg-[#faf1ff] text-[#9e65bb] dark:text-gray-300 dark:bg-[#522868] border-b-2 border-[#9b59bf] shadow-sm"
                      : "text-gray-600 hover:bg-purple-50 hover:text-[#9e68ba] dark:hover:bg-[#6e358c] dark:text-gray-300"
                  }`}
                  onClick={() => handleTabChange("recent")}
                >
                  {t("Products.tabs.recent")}
                </button>
                <button
                  className={`px-6 py-3 text-sm font-medium transition-all duration-200 ${
                    selectedFilterDate === "popular"
                      ? "bg-[#faf1ff] text-[#9e65bb] dark:text-gray-300 dark:bg-[#522868] border-b-2 border-[#9b59bf] shadow-sm"
                      : "text-gray-600 hover:bg-purple-50 hover:text-[#9e68ba] dark:hover:bg-[#6e358c] dark:text-gray-300"
                  }`}
                  onClick={() => handleTabChange("popular")}
                >
                  {t("Products.tabs.popular")}
                </button>
              </div>
            </div>
          </div>

          {/* Status Filter Cards */}
          <div className="mx-3 mb-4 overflow-x-auto pb-2 ">
            <div
              className={`flex md:grid md:grid-cols-4 lg:grid-cols-4 gap-3 ${
                direction === "rtl" ? "text-right" : "text-left"
              }`}
            >
              <button
                onClick={() => setFilter2("")}
                className={`flex-shrink-0 w-52 sm:w-auto flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${
                  filter2 === ""
                    ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                    : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg ${
                    filter2 === ""
                      ? "bg-[#efd3ff] dark:bg-[#181919]"
                      : "bg-[#faf1ff] dark:bg-[#181919]"
                  } flex items-center justify-center ${
                    direction === "rtl" ? "ml-3" : "mr-3"
                  }`}
                >
                  <Package
                    size={18}
                    className={`${
                      filter2 === "" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                    }`}
                  />
                </div>
                <div
                  className={`mx-2 ${
                    direction === "rtl" ? "text-right" : "text-left"
                  }`}
                >
                  <div
                    className={`text-sm font-medium ${
                      filter2 === ""
                        ? "text-[#9e68ba]"
                        : "text-gray-800 dark:!text-gray-300"
                    }`}
                  >
                    {t("Products.filters.all")}
                  </div>
                  <div
                    className={`font-bold ${
                      filter2 === "" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                    }`}
                  >
                    {totalProducts}
                  </div>
                </div>
              </button>

              {/* Répétez le même modèle pour les autres boutons */}
              <button
                onClick={() => setFilter2("out_of_stock")}
                className={`flex-shrink-0 w-52 sm:w-auto flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${
                  filter2 === "out_of_stock"
                    ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                    : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg ${
                    filter2 === "out_of_stock"
                      ? "bg-[#efd3ff] dark:bg-[#181919]"
                      : "bg-[#faf1ff] dark:bg-[#181919]"
                  } flex items-center justify-center ${
                    direction === "rtl" ? "ml-3" : "mr-3"
                  }`}
                >
                  <Archive
                    size={18}
                    className={`${
                      filter2 === "out_of_stock"
                        ? "text-[#9e65bb]"
                        : "text-[#9e68ba]"
                    }`}
                  />
                </div>
                <div
                  className={`mx-2 ${
                    direction === "rtl" ? "text-right" : "text-left"
                  }`}
                >
                  <div
                    className={`text-sm font-medium ${
                      filter2 === "out_of_stock"
                        ? "text-[#9e68ba]"
                        : "text-gray-800 dark:!text-gray-300"
                    }`}
                  >
                    {t("Products.filters.out_of_stock")}
                  </div>
                  <div
                    className={`font-bold ${
                      filter2 === "out_of_stock"
                        ? "text-[#9e65bb]"
                        : "text-[#9e68ba]"
                    }`}
                  >
                    {outOfStock}
                  </div>
                </div>
              </button>

              <button
                onClick={() => setFilter2("low_stock")}
                className={`flex-shrink-0 w-52 sm:w-auto flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${
                  filter2 === "low_stock"
                    ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                    : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg ${
                    filter2 === "low_stock"
                      ? "bg-[#efd3ff] dark:bg-[#181919]"
                      : "bg-[#faf1ff] dark:bg-[#181919]"
                  } flex items-center justify-center ${
                    direction === "rtl" ? "ml-3" : "mr-3"
                  }`}
                >
                  <AlertCircle
                    size={18}
                    className={`${
                      filter2 === "low_stock"
                        ? "text-[#9e65bb]"
                        : "text-[#9e68ba]"
                    }`}
                  />
                </div>
                <div
                  className={`mx-2 ${
                    direction === "rtl" ? "text-right" : "text-left"
                  }`}
                >
                  <div
                    className={`text-sm font-medium ${
                      filter2 === "low_stock"
                        ? "text-[#9e68ba]"
                        : "text-gray-800 dark:!text-gray-300"
                    }`}
                  >
                    {t("Products.filters.low_stock")}
                  </div>
                  <div
                    className={`font-bold ${
                      filter2 === "low_stock"
                        ? "text-[#9e65bb]"
                        : "text-[#9e68ba]"
                    }`}
                  >
                    {lowStock}
                  </div>
                </div>
              </button>
              <button
                onClick={() => setFilter2("ai_generated")}
                className={`flex-shrink-0 w-52 sm:w-auto flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${
                  filter2 === "ai_generated"
                    ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                    : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg ${
                    filter2 === "ai_generated"
                      ? "bg-[#efd3ff] dark:bg-[#181919]"
                      : "bg-[#faf1ff] dark:bg-[#181919]"
                  } flex items-center justify-center ${
                    direction === "rtl" ? "ml-3" : "mr-3"
                  }`}
                >
                  <Sparkle
                    size={18}
                    className={`${
                      filter2 === "ai_generated"
                        ? "text-[#9e65bb]"
                        : "text-[#9e68ba]"
                    }`}
                  />
                </div>
                <div
                  className={`mx-2 ${direction === "rtl" ? "text-right" : "text-left"}`}
                >
                  <div
                    className={`text-sm font-medium ${
                      filter2 === "ai_generated"
                        ? "text-[#9e68ba]"
                        : "text-gray-800 dark:!text-gray-300"
                    }`}
                  >
                    {t("Products.filters.ai_generated")}
                  </div>
                  <div
                    className={`font-bold ${
                      filter2 === "ai_generated"
                        ? "text-[#9e65bb]"
                        : "text-[#9e68ba]"
                    }`}
                  >
                    {aiGeneratedProducts}
                  </div>
                </div>
              </button>
              <button
                onClick={() => setFilter2("hidden")}
                className={`flex-shrink-0 w-52 sm:w-auto flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${
                  filter2 === "hidden"
                    ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                    : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg ${
                    filter2 === "hidden"
                      ? "bg-[#efd3ff] dark:bg-[#181919]"
                      : "bg-[#faf1ff] dark:bg-[#181919]"
                  } flex items-center justify-center ${
                    direction === "rtl" ? "ml-3" : "mr-3"
                  }`}
                >
                  <EyeOff
                    size={18}
                    className={`${
                      filter2 === "hidden" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                    }`}
                  />
                </div>
                <div
                  className={`mx-2 ${
                    direction === "rtl" ? "text-right" : "text-left"
                  }`}
                >
                  <div
                    className={`text-sm font-medium ${
                      filter2 === "hidden"
                        ? "text-[#9e68ba]"
                        : "text-gray-800 dark:!text-gray-300"
                    }`}
                  >
                    {t("Products.filters.hidden")}
                  </div>
                  <div
                    className={`font-bold ${
                      filter2 === "hidden" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                    }`}
                  >
                    {hiddenProducts}
                  </div>
                </div>
              </button>
            </div>
          </div>

          {/* Search and Filter Bar */}
          <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-sm p-4 mx-3 mb-4 border border-purple-100 dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div className="relative flex-grow max-w-xl">
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <Search size={16} className="text-gray-400" />
                </div>
                <input
                  type="text"
                  className="bg-gray-50 border border-gray-200 dark:!border-[#3c3a3d] dark:!bg-[#181919] text-gray-900 text-sm rounded-lg block w-full pr-10 p-2.5 focus:outline-none focus:ring-2 focus:ring-purple-200"
                  placeholder={t("Products.searchPlaceholder")}
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                />
              </div>

              <div className="flex flex-wrap items-center justify-between gap-3">
                <div className="flex items-center gap-3">
                  <div className="relative ">
                    {/* Main Trigger Button */}
                    <div
                      onClick={() =>
                        setIsProductsPageSizeOpen(!isProductsPageSizeOpen)
                      }
                      className="dark:!bg-[#181919] dark:!border-[#3c3a3d] group relative bg-gray-50 border border-gray-200 hover:border-[#9b59bf] text-gray-900 text-sm rounded-lg p-2.5 cursor-pointer min-w-[160px] transition-all duration-200 hover:shadow-sm focus:ring-2 focus:ring-purple-200"
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          {/* Products Icon */}
                          <div className="dark:bg-[#181919] w-5 h-5 bg-[#faf1ff] rounded-md flex items-center justify-center">
                            <svg
                              className="w-3 h-3 text-[#9b59bf]"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                            </svg>
                          </div>

                          {/* Current Selection */}
                          <span className="font-medium text-gray-900 dark:text-gray-300">
                            {productsPageSizeOptions.find(
                              (option) => option.value == pageSize,
                            )?.label || t("Products.10prod")}
                          </span>
                        </div>

                        {/* Arrow Icon with Animation */}
                        <div
                          className={`transform transition-transform duration-200 ${
                            isProductsPageSizeOpen ? "rotate-180" : ""
                          }`}
                        >
                          <svg
                            className="w-4 h-4 text-gray-500"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>

                    {/* Dropdown Menu */}
                    <div className="relative">
                      {isProductsPageSizeOpen && (
                        <>
                          {/* Backdrop for mobile */}
                          <div
                            className="fixed inset-0  bg-opacity-5 z-40 md:hidden"
                            onClick={() => setIsProductsPageSizeOpen(false)}
                          />

                          {/* Dropdown Container */}
                          <div
                            className="absolute mt-1 bg-white dark:!bg-[#181919] border border-gray-200 dark:!border-[#3c3a3d] rounded-lg shadow-lg overflow-hidden w-full animate-in slide-in-from-top-1 duration-150"
                            style={{ zIndex: 100000 }}
                          >
                            {/* Header */}
                            <div className="bg-[#faf1ff] dark:bg-[#141414] px-4 py-2.5 border-b border-purple-100 dark:!border-[#3c3a3d]">
                              <span className="font-medium text-gray-800 dark:text-gray-300 text-sm">
                                {t("orders.orders_per_page")}
                              </span>
                            </div>

                            {/* Options List */}
                            <div className="max-h-48 overflow-y-auto">
                              {productsPageSizeOptions.map((option) => {
                                const isSelected = pageSize == option.value;
                                return (
                                  <button
                                    key={option.value}
                                    onClick={() =>
                                      handleProductsPageSizeSelect(option.value)
                                    }
                                    className={`w-full group flex items-center gap-2 px-4 py-2.5 hover:bg-[#faf1ff] cursor-pointer transition-colors duration-150 text-right ${
                                      isSelected
                                        ? "bg-[#faf1ff] dark:!bg-[#2a2b2b] border-r-2 border-[#9b59bf]"
                                        : ""
                                    }`}
                                  >
                                    {/* Selection Indicator */}
                                    <div className="relative flex-shrink-0">
                                      <div
                                        className={`w-4 h-4 rounded-full border transition-all duration-200 flex items-center justify-center ${
                                          isSelected
                                            ? "bg-[#9b59bf] border-[#9b59bf]"
                                            : "border-gray-300 hover:border-[#9b59bf]"
                                        }`}
                                      >
                                        {isSelected && (
                                          <div className="w-2 h-2 bg-white rounded-full" />
                                        )}
                                      </div>
                                    </div>

                                    {/* Option Label */}
                                    <span
                                      className={`text-sm transition-colors ${
                                        isSelected
                                          ? "text-[#9b59bf] font-medium"
                                          : "text-gray-800 dark:text-gray-300 group-hover:text-[#9b59bf]"
                                      }`}
                                    >
                                      {option.label}
                                    </span>
                                  </button>
                                );
                              })}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  {(!account.productMode ||
                    account.productMode === "classic") && (
                    <button
                      onClick={
                        !!account.store ? handleOpenExportModal : message
                      }
                      className="bg-[#9b59bf] hover:bg-[#814a9f] transition-colors text-white py-2 px-4 rounded-lg text-sm font-medium flex items-center justify-center"
                    >
                      <Import size={18} className="ml-2" />
                      <span>{t("Products.importProduct")}</span>
                    </button>
                  )}
                </div>
                <button
                  onClick={!!account.store ? handleAdd : message}
                  className="w-full sm:w-auto bg-[#9b59bf] hover:bg-[#814a9f] transition-colors text-white py-2 px-4 rounded-lg text-sm font-medium flex items-center justify-center"
                >
                  <Plus size={18} className="ml-2" />
                  <span>{t("Products.addProduct")}</span>
                </button>
                <button
                  onClick={() => setAiModalShow(true)}
                  className="w-full sm:w-auto bg-[#9b59bf] hover:bg-[#814a9f] transition-colors text-white py-2 px-4 rounded-lg text-sm font-medium flex items-center justify-center"
                >
                  <Sparkle set="curved" size={18} />
                  <span className="hp-ml-8" style={{ marginRight: "8px" }}>
                    {t("landing.create_with_ai")}
                  </span>
                </button>
              </div>
            </div>
          </div>

          <ProductExportModal
            isOpen={exportModalOpen}
            onClose={() => setExportModalOpen(false)}
          />

          {/* Data Table */}
          <div className="mx-3 bg-white rounded-xl shadow-sm border border-purple-100 dark:!border-[#3c3a3d] p-0 mb-6 overflow-hidden">
            <DataTableTemplatingDemo
              lgShow={lgShow}
              setLgShow={setLgShow}
              modelShow={modelShow}
              setModelShow={setModelShow}
              setImages={setImages}
              data={data}
              setData={setData}
              filter={filter}
              filter2={filter2}
              pageSize={pageSize}
              filteredProducts={getFilteredProducts()}
              allProducts={products}
            />
          </div>

          <Footer />
        </div>
      </div>
      <ModelAdd
        lgShow={lgShow}
        setLgShow={setLgShow}
        data={data}
        setData={setData}
        categories={data2}
        onSave={handleModalSave}
      />
      <AIPageProducts
        show={aiModalShow}
        setShow={setAiModalShow}
        isGenerating={isGenerating}
        existingProducts={products}
        onGenerate={handleGenerateLandingPage}
        onConfirm={handleConfirmAiPage}
      />
      <ModelShow lgShow={modelShow} setLgShow={setModelShow} images={images} />
    </div>
  );
}

export default Products;
